<div class="window-container sideboard-container" [class.minimized]="isMinimized" [class.maximized]="options?.isMaximized">
  <div class="window-header">
    <div class="window-title">{{ options?.Header?.Title }}</div>
    <div class="window-control-buttons">
      <div *ngIf="options.VisibleMaximize" class="maximize-button">
        <mat-icon (click)="toggleMaximize()">
          {{ options?.isMaximized ? 'fullscreen_exit' : 'fullscreen' }}
        </mat-icon>
      </div>

      <div *ngIf="options.VisibleMini">
        <mat-icon (click)="minimizeWindow()">minimize</mat-icon>
      </div>

      <div *ngIf="options.VisibleClose">
        <mat-icon (click)="onClose()" mat-dialog-close>close</mat-icon>
      </div>
    </div>
  </div>

  <div class="window-body">
    <ng-content select="[content]"></ng-content>
  </div>

  <div
    class="window-footer"
    *ngIf="options?.Footer?.Visible !== false"
    style="width: 100%; margin: 0px"
  >
    <div class="d-flex row" style="width: 100%; margin: 0px">
      <div class="col" style="padding: 0px">
        <button
          mat-icon-button
          type="button"
          [disabled]="okButtonDisabled"
          [mat-dialog-close]="data"
          (click)="onOk()"
          *ngIf="options?.Footer?.ShowOk !== false"
          style="padding: 0px; height: 40px; width: 40px"
        >
          <mat-icon style="margin-top: -4px; margin-left: -4px">check</mat-icon>
        </button>
      </div>

      <div class="col" style="padding: 0px">
        <button
          mat-icon-button
          type="button"
          [disabled]="okAllButtonDisabled"
          [mat-dialog-close]="data"
          (click)="onOkAll()"
          *ngIf="options?.Footer?.ShowOkAll === true"
          style="padding: 0px; height: 40px; width: 40px"
        >
          <mat-icon style="margin-top: -4px; margin-left: -4px">done_all</mat-icon>
        </button>
      </div>

      <div class="col" style="padding: 0px; text-align: right">
        <button
          mat-icon-button
          (click)="onClose()"
          mat-dialog-close
          *ngIf="options?.Footer?.ShowCancel !== false"
          style="padding: 0px; height: 40px; width: 40px"
        >
          <mat-icon color="warn" style="margin-top: -4px; margin-left: -4px">close</mat-icon>
        </button>
      </div>

      <div
        class="d-flex justify-content-end"
        [ngClass]="{
          'col-7': options?.Footer?.ShowOk,
          'col-12': !options?.Footer?.ShowOk
        }"
        style="padding: 0px"
      >
        <ng-content select="[footer]" id="footer"></ng-content>
      </div>
    </div>
  </div>
</div>
